import { useState } from 'react';
import { useToast } from './use-toast';
import { interviewsApi } from '../lib/api';

const DEFAULT_OPENING =
  `Hi {{candidate_name}},\n\nmy name is Zara, {{company_name}}'s AI Recruiter.\n\nThank you for joining the interview. How's your day going so far?`;

export function useInterviewNaming() {
  const [name, setName] = useState('');
  const [openingPhrase, setOpeningPhrase] = useState(DEFAULT_OPENING);
  return { name, setName, openingPhrase, setOpeningPhrase };
}

/**
 * Handles the Review / Save click. Persists to backend and fires callbacks.
 * Returns { submit, submitting } where submit(payload) saves.
 */
export function useInterviewReview({ onClose, onSaved }) {
  const { toast } = useToast();
  const [submitting, setSubmitting] = useState(false);

  const submit = async ({ name, flow, openingPhrase, totalDuration }) => {
    if (!name.trim()) {
      toast({ title: 'Name required', description: 'Please name the interview before reviewing.' });
      return;
    }
    setSubmitting(true);
    try {
      await interviewsApi.create({
        name: name.trim(),
        flow,
        opening_phrase: openingPhrase,
        total_duration: totalDuration,
      });
      toast({ title: 'Interview saved', description: `"${name}" is ready.` });
      onSaved?.();
      onClose();
    } catch (e) {
      const msg = e?.response?.data?.detail || e?.message || 'Failed to save interview';
      toast({ title: 'Save failed', description: msg });
    } finally {
      setSubmitting(false);
    }
  };

  return { submit, submitting };
}
